/** Operator links shown in the /staff nav. One list so adding a tool is one line. */
export interface StaffLink {
  label: string;
  href: string;
}

export const STAFF_LINKS: StaffLink[] = [
  // Behind Caddy basic_auth (infra/Caddyfile); Netdata itself is not public.
  { label: 'Netdata', href: 'https://netdata.skiffs.app' },
  { label: 'PocketBase', href: 'https://api.skiffs.app/_/' },
  { label: 'Uptime', href: 'https://dashboard.uptimerobot.com' },
  { label: 'PostHog', href: 'https://us.posthog.com' },
  { label: 'RevenueCat', href: 'https://app.revenuecat.com' },
  { label: 'Linear', href: 'https://linear.app/cubicletwo/team/SK' },
];
